export default __webpack_public_path__ + "static/media/360.43d585c9.png";